"use client";

import { useState } from 'react';

export default function HealthcareDashboardsSection() {
  const [activeTab, setActiveTab] = useState(0);

  const dashboards = [
    {
      title: 'CEO / CFO HOSPITAL DASHBOARD',
      subtitle: 'Hospital Financial & Operational Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Hospital Executive Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'Bed Occupancy Rate', value: '84%', color: '#C5A572' },
            { x: 186, label: 'Avg Length of Stay', value: '4.2 days', color: '#1B2845' },
            { x: 356, label: 'Patient Acquisition Cost', value: '₹3,840', color: '#16a34a' },
            { x: 526, label: 'Revenue Leakage', value: '0.8%', color: '#16a34a' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
            </g>
          ))}

          {/* Revenue Trends Line Chart */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Hospital Revenue Trends (₹Cr)</text>
          <polyline points="40,285 80,270 120,275 160,255 200,260 240,240 280,235 320,218 340,210" fill="none" stroke="#1B2845" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="40,285 80,270 120,275 160,255 200,260 240,240 280,235 320,218 340,210 340,295 40,295 Z" fill="#1B2845" opacity="0.06" />
          {[40,80,120,160,200,240,280,320,340]?.map((x, i) => (
            <circle key={i} cx={x} cy={[285,270,275,255,260,240,235,218,210]?.[i]} r="3" fill="#C5A572" />
          ))}
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep']?.map((m, i) => (
            <text key={i} x={[40,80,120,160,200,240,280,320,340]?.[i] - 8} y="308" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{m}</text>
          ))}

          {/* Department Profitability */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Department Profitability</text>
          {[
            { dept: 'Cardiology', margin: '28.4%', color: '#16a34a', w: 200 },
            { dept: 'Orthopaedics', margin: '22.1%', color: '#65a30d', w: 155 },
            { dept: 'Oncology', margin: '18.6%', color: '#ca8a04', w: 130 },
            { dept: 'General Medicine', margin: '12.3%', color: '#ea580c', w: 86 },
            { dept: 'Emergency', margin: '4.8%', color: '#dc2626', w: 34 },
          ]?.map((d, i) => (
            <g key={i}>
              <text x="370" y={168 + i * 26} fill="#374151" fontSize="9" fontFamily="sans-serif">{d?.dept}</text>
              <rect x="470" y={156 + i * 26} width={d?.w} height="14" fill={d?.color} rx="2" opacity="0.75" />
              <text x="476" y={168 + i * 26} fill="white" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{d?.margin}</text>
            </g>
          ))}

          {/* Insurance Reimbursement */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Insurance Reimbursement Performance</text>
          {[
            { insurer: 'Star Health', rate: '94%', days: '12 days', color: '#16a34a' },
            { insurer: 'HDFC Ergo', rate: '88%', days: '18 days', color: '#65a30d' },
            { insurer: 'New India', rate: '82%', days: '24 days', color: '#ca8a04' },
            { insurer: 'United India', rate: '71%', days: '32 days', color: '#dc2626' },
          ]?.map((ins, i) => (
            <g key={i}>
              <text x={28 + i * 168} y="358" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{ins?.insurer}</text>
              <text x={28 + i * 168} y="372" fill="#6b7280" fontSize="9" fontFamily="sans-serif">Approval: {ins?.rate}</text>
              <text x={28 + i * 168} y="386" fill={ins?.color} fontSize="9" fontWeight="bold" fontFamily="sans-serif">Avg: {ins?.days}</text>
              <rect x={28 + i * 168} y="390" width={parseInt(ins?.rate) * 0.9} height="6" fill={ins?.color} rx="2" opacity="0.6" />
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'CLINICAL LEADERSHIP DASHBOARD',
      subtitle: 'Patient Outcomes & Clinical Performance',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Clinical Leadership Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'Readmission Rate', value: '8.2%', color: '#ca8a04' },
            { x: 186, label: 'Patient Satisfaction', value: '4.6/5', color: '#16a34a' },
            { x: 356, label: 'Avg Recovery Time', value: '5.8 days', color: '#1B2845' },
            { x: 526, label: 'High Risk Patients', value: '24', color: '#dc2626' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="20" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
            </g>
          ))}

          {/* Patient Admission Trend */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Patient Admission Trend</text>
          <polyline points="40,280 80,265 120,270 160,250 200,255 240,238 280,232 320,218 340,210" fill="none" stroke="#C5A572" strokeWidth="2.5" strokeLinecap="round" />
          <polyline points="40,280 80,265 120,270 160,250 200,255 240,238 280,232 320,218 340,210 340,295 40,295 Z" fill="#C5A572" opacity="0.08" />
          {[40,80,120,160,200,240,280,320,340]?.map((x, i) => (
            <circle key={i} cx={x} cy={[280,265,270,250,255,238,232,218,210]?.[i]} r="3" fill="#1B2845" />
          ))}
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep']?.map((m, i) => (
            <text key={i} x={[40,80,120,160,200,240,280,320,340]?.[i] - 8} y="308" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{m}</text>
          ))}

          {/* Patient Risk Alerts */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Patient Risk Alerts</text>
          {[
            { patient: 'Ward 4B — Bed 12', risk: 'Sepsis risk HIGH', color: '#dc2626', bg: '#fef2f2' },
            { patient: 'ICU — Bed 3', risk: 'Deterioration MED', color: '#ea580c', bg: '#fff7ed' },
            { patient: 'Ward 2A — Bed 7', risk: 'Readmission risk MED', color: '#ea580c', bg: '#fff7ed' },
            { patient: 'Ward 6C — Bed 2', risk: 'Medication review LOW', color: '#ca8a04', bg: '#fefce8' },
          ]?.map((alert, i) => (
            <g key={i}>
              <rect x="370" y={158 + i * 36} width="302" height="28" fill={alert?.bg} rx="5" />
              <text x="382" y={170 + i * 36} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{alert?.patient}</text>
              <text x="382" y={182 + i * 36} fill={alert?.color} fontSize="9" fontFamily="sans-serif">{alert?.risk}</text>
            </g>
          ))}

          {/* Clinical Outcomes */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Treatment Effectiveness by Department</text>
          {[
            { dept: 'Cardiology', eff: 92, color: '#16a34a' },
            { dept: 'Orthopaedics', eff: 88, color: '#65a30d' },
            { dept: 'Oncology', eff: 76, color: '#ca8a04' },
            { dept: 'Neurology', eff: 84, color: '#3b82f6' },
          ]?.map((d, i) => (
            <g key={i}>
              <text x={28 + i * 168} y="358" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{d?.dept}</text>
              <rect x={28 + i * 168} y="364" width="140" height="12" fill="#f3f4f6" rx="3" />
              <rect x={28 + i * 168} y="364" width={d?.eff * 1.4} height="12" fill={d?.color} rx="3" opacity="0.8" />
              <text x={28 + i * 168} y="392" fill={d?.color} fontSize="9" fontWeight="bold" fontFamily="sans-serif">{d?.eff}% effective</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'HOSPITAL OPERATIONS DASHBOARD',
      subtitle: 'Capacity, Flow & Staff Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Hospital Operations Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'Staff Productivity', value: '87%', color: '#16a34a' },
            { x: 186, label: 'Discharge Turnaround', value: '3.4 hrs', color: '#C5A572' },
            { x: 356, label: 'ED Wait Time', value: '28 min', color: '#ca8a04' },
            { x: 526, label: 'Bed Turnover Rate', value: '4.2×', color: '#1B2845' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="20" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
            </g>
          ))}

          {/* Bed Utilization Heatmap */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Bed Utilization by Department</text>
          {[
            { dept: 'ICU', util: 96, color: '#dc2626' },
            { dept: 'Cardiology', util: 88, color: '#ea580c' },
            { dept: 'Orthopaedics', util: 82, color: '#ca8a04' },
            { dept: 'General Medicine', util: 74, color: '#65a30d' },
            { dept: 'Paediatrics', util: 61, color: '#16a34a' },
            { dept: 'Maternity', util: 55, color: '#16a34a' },
          ]?.map((d, i) => (
            <g key={i}>
              <text x="28" y={168 + i * 22} fill="#374151" fontSize="9" fontFamily="sans-serif">{d?.dept}</text>
              <rect x="130" y={156 + i * 22} width="170" height="12" fill="#f3f4f6" rx="3" />
              <rect x="130" y={156 + i * 22} width={d?.util * 1.7} height="12" fill={d?.color} rx="3" opacity="0.75" />
              <text x="308" y={167 + i * 22} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{d?.util}%</text>
            </g>
          ))}

          {/* ED Wait Times */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">ED Wait Times by Hour</text>
          {[22,28,35,42,38,30,25,20,18,22,28,32]?.map((val, i) => (
            <g key={i}>
              <rect x={375 + i * 24} y={295 - val * 2.5} width="18" height={val * 2.5} fill={val > 35 ? '#dc2626' : val > 25 ? '#ca8a04' : '#16a34a'} rx="2" opacity="0.8" />
              <text x={375 + i * 24 + 2} y="308" fill="#9ca3af" fontSize="7" fontFamily="sans-serif">{6 + i}h</text>
            </g>
          ))}
          <line x1="370" y1="295" x2="680" y2="295" stroke="#e5e7eb" strokeWidth="1" />

          {/* Equipment Utilization */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Equipment Utilization</text>
          {[
            { equip: 'MRI Machines', util: 78, color: '#1B2845' },
            { equip: 'CT Scanners', util: 85, color: '#C5A572' },
            { equip: 'Ventilators', util: 62, color: '#3b82f6' },
            { equip: 'Operation Theatres', util: 91, color: '#16a34a' },
          ]?.map((e, i) => (
            <g key={i}>
              <text x={28 + i * 168} y="358" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{e?.equip}</text>
              <rect x={28 + i * 168} y="364" width="140" height="12" fill="#f3f4f6" rx="3" />
              <rect x={28 + i * 168} y="364" width={e?.util * 1.4} height="12" fill={e?.color} rx="3" opacity="0.8" />
              <text x={28 + i * 168} y="392" fill={e?.color} fontSize="9" fontWeight="bold" fontFamily="sans-serif">{e?.util}% utilized</text>
            </g>
          ))}
        </svg>
      ),
    },
  ];

  return (
    <section className="py-24 bg-cream px-4 sm:px-6 lg:px-8 xl:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-navy text-2xl sm:text-3xl md:text-4xl xl:text-[3rem] leading-[1.2] font-bold mb-4">
            Role-Specific Intelligence for <span className="italic">Healthcare Leaders</span>
          </h2>
          <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">
            Purpose-built dashboards for every decision-maker in your healthcare organization.
          </p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {dashboards?.map((d, i) => (
            <button
              key={i}
              onClick={() => setActiveTab(i)}
              className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 ${
                activeTab === i
                  ? 'bg-navy text-white shadow-md'
                  : 'bg-white text-navy border border-gray-200 hover:border-gold/40'
              }`}
            >
              {d?.title}
            </button>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 shadow-sm">
          <div className="mb-4">
            <h3 className="font-serif text-navy text-xl font-bold">{dashboards?.[activeTab]?.title}</h3>
            <p className="text-charcoal/60 text-sm mt-1">{dashboards?.[activeTab]?.subtitle}</p>
          </div>
          <div className="w-full aspect-[700/420] rounded-xl overflow-hidden border border-gray-100">
            {dashboards?.[activeTab]?.svg}
          </div>
          <div className="flex gap-4 mt-6">
            <button className="bg-navy hover:bg-navy/90 text-white text-sm font-semibold px-6 py-2.5 rounded-lg transition-all duration-200">
              View Demo
            </button>
            <button className="border border-navy text-navy hover:bg-navy/5 text-sm font-semibold px-6 py-2.5 rounded-lg transition-all duration-200">
              Request Customization
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
